import React, {useEffect, useState} from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import {Route, Routes, BrowserRouter} from "react-router-dom";
import {Provider} from "react-redux";
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import store from './store/store.js';
import  config  from "./config";
import { ReactQueryDevtools } from 'react-query/devtools'
import {SnackbarProvider} from "notistack";
import Login from "./pages/Auth/login";
import AppBase from "./layouts/AppBase";
import {useGetProfile} from "./store/actions/AuthAction";
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import ptBR from 'date-fns/locale/pt-BR'
import {log} from "./utils/log";
import {loadStatusDee} from "./utils/utility";
import AppBaseMobile from "./layouts/AppBaseMobile";
import MobileScanPage from "./pages/MobileScan";
import fermiTheme from "./theme/fermiTheme";
import {checkForUpdates, forceReload} from "./utils/versionCheck";

const App = () => {
  document.title = config.TITLE +" - "+ config.VERSAO;
  const { error } = useGetProfile();
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    loadStatusDee();
    checkForUpdates().then((needsUpdate) => {
      if (needsUpdate) {
        setIsUpdating(true);
        setTimeout(() => forceReload(), 1500);
      }
    });
  }, []);

  useEffect(() => {
    if (error) {
      log(0, "App.js: useEffect: error: ", error);
      // navigate("/login");
    }
  }, [error]);

  if (isUpdating) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: '#1a237e',
        color: '#fff',
        fontFamily: 'Roboto, sans-serif',
      }}>
        <div style={{
          width: 48,
          height: 48,
          border: '4px solid rgba(255,255,255,0.3)',
          borderTopColor: '#fff',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
        }} />
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        <h2 style={{ marginTop: 24, fontWeight: 400 }}>Atualizando web...</h2>
        <p style={{ opacity: 0.7, fontSize: 14 }}>Uma nova versão está disponível</p>
      </div>
    );
  }



  return (

      <Provider store={store}>
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
            <StyledEngineProvider injectFirst >
              <ThemeProvider theme={fermiTheme}>
                <CssBaseline/>

                  <SnackbarProvider maxSnack={5}>
                      <BrowserRouter>

                        <Routes>

                          <Route path="login" element={ <Login/> }  />
                          <Route path="mobile-scan/:personId" element={ <MobileScanPage/> } />
                          <Route path="mob/*" element={ <AppBaseMobile/> } />
                          <Route path="*" element={ <AppBase/> } />

                        </Routes>

                    </BrowserRouter>

                  <ReactQueryDevtools initialIsOpen={true} />
                  </SnackbarProvider>


              </ThemeProvider>
            </StyledEngineProvider>
          </LocalizationProvider>
      </Provider>
  );
};

export default App;